module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chapname1"
  }, [_vm._v("one")]), _vm._v(" "), _c('div', {
    staticClass: "img_container2"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0039-00.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapname"
  }, [_c('span', {
    staticClass: "chaps"
  }, [_vm._v("W")]), _vm._v("AR COMES TO THE COLUMBIA COUNTRY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "ts32"
  }, [_vm._v("Nelson was dead. Immortality had ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("enshrined him as a result of his brilliant crushing of the combined French and Spanish fleets at Trafalgar.")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Napoleon held sway in Europe, though mauled by an ill-judged attack on Moscow. The French soon regained strength at sea. All the same, British mastery of the oceans stood in his way. “So I, had I remained in Egypt, should probably have founded an empire like Alexander,” said Napoleon. He was received on board HMS ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Bellerophon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and taken into custody, his eventual destination one of lonely exile on St. Helena in the South Atlantic. He complained acidly to Captain Frederick Maitland of the British man-of-war: “Had it not been for you English, I should have been Emperor of the East; but whenever there is water to float a ship we are sure to find you in the way.” In the words of the distinguished American historian Alfred Thayer Mahan, “those far-distant, storm-beaten ships upon which the Grand Army never looked, stood between it and the dominion of the world.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn1",
      "id": "c1_n1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("After Trafalgar the British had not rested on their oars. Caught in the jaws of fate, Britain raised a mighty navy for the final act to defeat Napoleon, and, in doing so, impressed seamen of British nationality who were found, on inspection, among the crews of United States naval vessels. President James Madison, backed by votes in the Senate and House of Representatives, proclaimed a state of war with Great Britain and the British Empire on June 19, 1812. In his message, Madison referred to the renewal of warfare by Native people “on one of our extensive frontiers.” He charged the British and the Canadians for this state of affairs. From this particular American point of view, the war would be fought to end the “Indian menace.” There was talk of taking Canada by mere marching. While the Americans planned their land campaign, the British made a pre-emptive move, took Michilimackinac on Lake Michigan and forced the surrender of Detroit, following on with a bloody campaign into western Ohio. They were joined in common cause by Tecumseh and his pan-Native alliance. Meantime, the United States bolstered its naval forces on lakes Ontario and Erie; the British, in more makeshift fashion, did likewise. In September 1813 the US Navy scored a resounding victory over Commodore Robert Barclay’s British squadron on Lake Erie, and then the tide of American sea power flowed north past Detroit into Lake Huron and beyond. Upper Canada’s existence lay in jeopardy, while naval, militia and even fur-trader resources stemmed the tide. The North West Company, self-interested patriots, raised various militia regiments and took the war to the enemy in the upper Michigan peninsula: indeed, they defended imperial interests as far west as Prairie du Chien on the upper Mississippi. At the same time, British generals and agents assured Tecumseh and his alliance that after the war their claims for a Native homeland in the interior would be honoured. That promise they could not keep, leading to charges of treachery on the British side.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-40"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/Img_0040-00.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "imagecaption"
  }, [_vm._v("Northwest Coast of North America, 1818–1846")]), _vm._v(" "), _c('p', {
    staticClass: "imagecaption_6"
  }, [_c('span', {
    staticClass: "ts36"
  }, [_vm._v("This map is reprinted with permission of the original publisher from ")]), _c('span', {
    staticClass: "ts37"
  }, [_vm._v("The Royal Navy on the Northwest Coast of North America, 1810–1914, ")]), _c('span', {
    staticClass: "ts36"
  }, [_vm._v("by Barry Gough © University of British Columbia Press 1971. All rights reserved by the publisher.")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-41"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-42"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("At stake, too, were issues of truly transcontinental scale. The war introduced a new factor in the rivalry between the Nor’westers and the Astorians. Late that year, North West Company agents in Montreal again urged their London partners to press the British government for convoy support of a Company supply ship bound for the Columbia River via Cape Horn. The outbreak of war in that year ended the British ministry’s indifference to the pleas of the North West Company; the Lords Commissioners of the Admiralty discussed the proposed mission with Nor’westers Donald McTavish and John Macdonald of Garth. They then dispatched the frigate ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", with 36 guns and under the command of Captain James Hillyar, to accompany the fur-trading company vessel ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to the Columbia River and then clear the coast of hostile vessels. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", 20 guns,")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("bearing letters-of-marque that would give her licence to capture enemy merchant shipping, was the first vessel of the Company’s Columbian enterprise. With the North West Company partners McTavish and Macdonald on board, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("sailed from Portsmouth with her escort, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", on March 25, 1813, under secret orders to seize Astoria and then form a British settlement at the mouth of the Columbia River.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn2",
      "id": "c1_n2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Now, at last, Canadian fur-trading zeal was being backed by British sea power and state policy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Meantime, an auxiliary expedition set out overland from Canada for the Columbia. Led by the veteran trader John George McTavish, the bold party of a hundred men intended to make the transcontinental crossing so as to meet up with the supply ship and naval escort sometime between May and August 1813. McTavish carried with him an important letter from the British government stating that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was “accompanied by a frigate, to take and destroy everything that is American on the N.W. Coast.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn3",
      "id": "c1_n3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("On June 10, 1813, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("led the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("into the neutral port of Rio de Janeiro.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn4",
      "id": "c1_n4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("There, the commander-in-chief of the South American station, Nova Scotia-born Rear-Admiral Sir Manley Dixon, learned that Hillyar had experienced great difficulty with the crew of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". Seven of the crew deserted on account of her unseaworthy condition; they had no desire to try to sail round Cape Horn in that ship.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn5",
      "id": "c1_n5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("She had proved to be a heavy sailer, in part because she was badly stowed and heavily rigged, and because she carried too many guns on deck. Her condition led Dixon to conclude, woefully, “No alteration, I understand, will make her sail even tolerably.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn6",
      "id": "c1_n6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("This was a secret mission, and Rear-Admiral Dixon knew nothing of its object until the ships reached Rio; he was disgusted when McTavish and Macdonald, in ignorance or indifference, “made generally known” that the secret destination of the ships was the Columbia River.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn7",
      "id": "c1_n7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("This breach of security outraged Dixon. He personified the qualities of duty, obedience and courage. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("spelled trouble to his command.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("About this time, news reached Dixon that the US frigate ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", rated by the British as a 40-gun ship, was at large in the Pacific, capturing British whalers at will.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn8",
      "id": "c1_n8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The admiral concluded that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("alone would not be an equal to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("should they meet in battle. He therefore designated two sloops under his command, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", 26 guns, and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(",")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-43"
    }
  }), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("18 guns, for this purpose. Both had been destined in the first instance for the South Pacific to protect the remaining British merchantmen, a service which could be most effectively accomplished by sinking or taking the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn9",
      "id": "c1_n9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("After considerable pondering, the commander-in-chief, with seamanlike precaution, ordered a squadron consisting of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to convoy the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to the Pacific, thus providing a greater margin of safety.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn10",
      "id": "c1_n10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("At Rio the crews readied the four vessels for the arduous passage round Cape Horn. Dixon ordered the government stores shipped in the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to be transferred to all three of the British men-of-war.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn11",
      "id": "c1_n11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("He strengthened")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("the complements of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("by a total of 65 men to ensure that the naval vessels would be strong enough to defeat the Americans at the mouth of the Columbia if the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("fell behind.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn12",
      "id": "c1_n12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Further delays followed when two officers left the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". Replacements had to be found, and discontented sailors from that ship had to be held in custody.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn13",
      "id": "c1_n13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Every effort was made to get under way as soon as possible, but the four ships did not weigh anchor until July 6, 1813.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Four days after leaving Rio, Captain Hillyar opened the secret Admiralty orders conveyed to him by Dixon. “The principal object of the Service on which you are employed,” the orders ran, “is to protect and render every assistance in your power to the British traders from Canada, and to destroy, and if possible totally annihilate any settlements which the Americans may have formed either on the Columbia River or on the neighbouring Coasts.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn14",
      "id": "c1_n14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Moreover, Hillyar was to give the Nor’westers “every assistance in the formation of any new settlement they may wish to form for carrying on their trade and in destroying any force of the Enemy which you may find in that quarter.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn15",
      "id": "c1_n15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The plan called for the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to arrive together at the Columbia after a passage from Rio “without touching anywhere.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn16",
      "id": "c1_n16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("In the")]), _vm._v(" event that the ships were separated or encountered difficulties, they were to rendezvous at the Hawaiian Islands, the best source of supplies. It was felt that to meet there would conceal the mission better than if they were to anchor in a port on the Pacific side of the Americas. As an alternative meeting place, the Island of Juan Fernandez off the Chilean coast was recommended.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-44"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Orders from Rear-Admiral Dixon required that one of the two furtrading partners should be placed aboard the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". With this precaution")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("could complete its mission even if the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("arrived late at the mouth of the Columbia or failed to reach there at all.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn17",
      "id": "c1_n17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Accordingly,")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Macdonald and five Company servants were transferred to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", and McTavish, the chief Nor’wester, remained in the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn18",
      "id": "c1_n18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Dixon’s")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("admirable instructions reminded Captain Hillyar of the original purpose of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("—to protect British merchantmen in the South Pacific—but gave him complete discretion to retain them as long as he thought necessary to accomplish the more important mission entrusted to him by the Admiralty.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn19",
      "id": "c1_n19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Although the mission to the Northwest Coast was supposedly a secret, details of its objective had leaked out even before the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("left England on March 25, 1813. This news reached Rio de Janeiro by mid-June; from there it probably was conveyed overland immediately and, passing through informants, eventually reached the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn20",
      "id": "c1_n20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", pride of Salem, Massachusetts, and a gift from the citizens of that city to the United States Navy, was the first US warship to enter the Pacific and had already been the first beyond the Cape of Good Hope.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn21",
      "id": "c1_n21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("After modest success against British shipping, mostly whalers, in the South Atlantic, Captain David Porter of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("decided to venture alone into the Pacific in March 1813 (about the same time the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("left Portsmouth). Porter planned to survive on the prizes he could capture. He provisioned hurriedly at Valparaiso, Chile, and sailed on March 21 for the Galapagos Islands, then the centre of whaling in the Pacific. From April to October 1813 the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("seized 12 of 20 British whalers.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn22",
      "id": "c1_n22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Captain")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Porter then fitted out one of these captured whalers as a privateer to accompany the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("in her search for unarmed, or poorly armed, merchantmen; the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex Junior")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", as the captured whaler was named, carried 20 light guns and 90 men.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-45"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("To this point, Porter had demonstrated in every respect fine seamanship and successful adherence to cruiser warfare, ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("guerre de course")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". Like John Paul Jones or Graf von Spee, he was master of that mode of naval warfare, living for the moment but with a plan to do as much damage to the enemy as possible while food, water and good fortune lasted. The US Navy had begun the war disadvantaged. While the British had always regarded the ever-difficult naval question as central to national existence, the Americans came to this late in the game, and the War of 1812 caught them unawares")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and unprepared. Those ships in commission were excellent and would do gallant service, even though they were few in number and could not prevent the blockade that the British squadrons maintained on the Atlantic seaboard. But their crack frigates, including the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", fought the type of naval war their commanders chose, and did so with commendable success.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Meanwhile, the British faced fearful difficulties in the passage from Rio to Cape Horn in the dead of the southern winter. During a heavy gale on July 20, 1813, the escorts almost lost sight of the slow-sailing ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", and the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("sustained minor damage as they tried to keep close to her. Two days later the captains met on board the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and decided that in the event of another gale they would be compelled, for reasons of safety, to sail at a distance from the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn23",
      "id": "c1_n23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Only a few days")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("later, on July 29, the ships were north of the Falkland Islands when thick fog settled in and the Company ship fell behind and lost contact. After weathering a heavy storm, the three men-of-war rounded Cape Horn; on September 11 they reached Crusoe’s Juan Fernandez, where they hoped to rendezvous with the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", but her whereabouts were still unknown. The squadron remained at Juan Fernandez for a week, hoping to sight the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". On September 18 the Nor’wester Macdonald and North West Company servants and stores were again transferred, this time from the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn24",
      "id": "c1_n24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The squadron then headed north, with the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac")]), _vm._v(" "), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("unaccounted for and perhaps lost.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Near the equator, on October 2, Hillyar learned from a Spanish brig that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had taken one hundred distressed seamen to Guayaquil on the coast of Ecuador.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn25",
      "id": "c1_n25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("It was thought that possibly these men were taken from the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". On this intelligence, which must have seemed convincing, Hillyar concluded that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was lost. He then decided to find the enemy. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("were sent to the South American coast to hunt for the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", leaving the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("—now unescorted—to continue to the Columbia River. Because the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had been allocated by the Lords of the Admiralty as escort for a project to which they attached importance, Hillyar’s decision to leave the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to execute the mission without escort could be justified only by success.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn26",
      "id": "c1_n26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-46"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("When Porter first learned of the strong British squadron sailing round the Horn, he prepared for battle. He intended to crown his time in the Pacific by something more splendid than catching enemy whalers. On "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("October 25 he took the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex Junior ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and three prizes to the salubrious Marquesas Islands, where a refit was carried out. He ran up the Stars and Stripes as an act of possession, later disavowed by the home government. Then on December 14 the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex Junior ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("sailed for Valparaiso, determined to seek combat with the enemy.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn27",
      "id": "c1_n27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("They reached what they considered to be the neutral port of Valparaiso on February 3, 1814; five days later the British ships ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("also entered the port but took up a position of close blockade.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("A clash between the rivals seemed inevitable as soon as both forces ventured out of the harbour. As he was stronger, Hillyar wanted to be in a position to prevent the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex Junior ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("from slipping away quietly before he was ready, so he put to sea, accompanied by the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". For nearly six weeks, Hillyar’s force sailed close to the extreme western point of Valparaiso harbour, a large open bay facing north. The objective was to prevent the faster enemy warships from escaping between him and the point. From his strategic position, Hillyar would have the advantage of a chase to windward in the prevailing south-southwest wind.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn28",
      "id": "c1_n28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Ill fortune now attended Porter, as the engagement he had sought would be fought under circumstances not of his own choosing. On March 28, 1814, in violent winds, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("parted one cable and began to drag another. Porter had no option but to cut the cable and make sail. He hoped to pass to the windward of the blockading British vessels. He might have done so had not the main topmast of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("snapped in a heavy squall near the outer point of the bay. This forced Porter to run eastward and to anchor in what has been claimed were “neutral” waters. This neutrality was debatable, since Britain did not recognize Chilean independence and Spain was an ally. Furthermore, no belligerent manof-war could hope to take advantage of neutral waters indefinitely, as the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had done.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Hillyar ignored Porter’s intent to take refuge in “neutral” waters and considered the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("fair game. His object was to rake the fine enemy frigate if possible, and, if not possible, to reach a range at which his long guns would be effective and her carronades would not. The powerful ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("mounted forty 32-pounder carronades and six 12-pounder long guns and had a minimum broadside of 676 pounds. By contrast, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("carried twenty-six 18-pounder long guns, four 9-pounder long guns and fourteen")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-47"
    }
  }), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("32-pounder carronades, while the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had eighteen 32-pounder carronades, six 18-pounder carronades and two 6-pounder guns, with minimum broadsides of 476 and 248 pounds respectively. These figures explain why Hillyar kept the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("in close company to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("outside Valparaiso harbour so as not to be placed at a disadvantage in a single-ship engagement with the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". They also partly explain Hillyar’s tactics in defeating the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn29",
      "id": "c1_n29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("(Readers with knowledge of Second World War naval history will imagine a parallel with the defeat of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Graf Spee ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("by forces under the White Ensign.) In the event, the greater gun-range and manoeuvrability of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("soon proved decisive. Hillyar gingerly kept his ships out of range of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("’s broadside while doing extensive damage aloft to the enemy.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn30",
      "id": "c1_n30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Faced with defeat, Porter surrendered, only two and one half")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("hours after action commenced.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn31",
      "id": "c1_n31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("By this single engagement, the Royal Navy gained command of the sea in the Pacific. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was entered on the Admiralty’s books and lists but ended her life as a convict ship in Ireland. Porter and his crew were released on good behaviour and arrived in New York to tumultuous acclaim. Meantime, the wisdom of Hillyar’s judgement now depended on whether the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("succeeded in her mission at the Columbia River mouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "section"
  }, [_vm._v("Astoria on the Brink")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("In sharp contrast to the assistance that the Royal Navy could now give the Nor’westers, American naval support for the Astorians became impossible as the British employed their naval supremacy in an effective blockade of American ports.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn32",
      "id": "c1_n32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("After Astor pleaded in 1813 for a warship to protect his")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("enterprise, the secretary of the Navy responded by arranging for the frigate ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Adams ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("to go to the North Pacific, but the British blockade prevented her from sailing. Astor then tried to protect the post and carry on the trade as best he could. He secretly chartered the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Forester")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", a British vessel under British colours, but by the time she reached the Northwest Coast, British fur traders were already in possession of Astoria. Her captain was forced to trade between California and Kamchatka on the Russian coast near the Kuril Islands.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn33",
      "id": "c1_n33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("In Hawaii, the commander of HMS ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("became suspicious of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Forester")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("’s ownership and detained some of her crew on board the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("also captured the American fur-trading vessel ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Charon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and the armed cruiser ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Sir Alexander Hammond ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("in the Sandwich Islands.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn34",
      "id": "c1_n34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-48"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Another of Astor’s ships, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Lark")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", was allowed by British naval authorities to leave New York in 1813 on the understanding that she was bound only for Sitka with goods and supplies for the Russians.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn35",
      "id": "c1_n35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("But she ran aground in the Hawaiian Islands and was a total loss. Astor, as one historian observed, “was the victim of bad tactics, bad luck, and bad strategy.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn36",
      "id": "c1_n36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Reverses")]), _vm._v(" between 1811 and 1815 dashed Astor’s hopes of maintaining Astoria as an essential link with the sea; at the same time, the partners of the Pacific Fur Company there became increasingly aware of their insecure position.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("In early October 1813, about six months before Captain David Porter surrendered to Captain Hillyar of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("near Valparaiso, John George McTavish, at the head of his party of Nor’westers, brought news overland to the Columbia River that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and a British frigate were bound for the river mouth to destroy the American post. This convinced the Astorians that their position was untenable. Additional and equally alarming news came from the Hawaiian and Marquesas Islands: Wilson P. Hunt, chief agent of the Pacific Fur Company, brought word from Hawaii of the outbreak of war between the two nations.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn37",
      "id": "c1_n37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("From the Marquesas, on")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("another occasion, he brought information from Captain Porter of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("that an even larger force than originally expected, consisting of a frigate, two sloops and a merchantman, was bound for the Northwest Coast to conquer Astoria. The disturbing news forwarded by Hunt on this second occasion was “the death warrant of unfortunate Astoria,” in the words of the American author Washington Irving.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn38",
      "id": "c1_n38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The Astorians were faced with a choice of selling their establishments, guns and stocks to the Nor’westers or confronting the guns of the Royal Navy and the Company vessel ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". They signed a bill of sale on October 16, 1813, nine days after the arrival of McTavish’s overland party.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn39",
      "id": "c1_n39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" This purchase would prove to be important during negotiations for peace and even after the war, but for now it signalled that Astor’s dream for a new western empire was shattered.")]), _vm._v(" "), _c('p', {
    staticClass: "section"
  }, [_c('span', {
    staticClass: "ts38"
  }, [_vm._v("The Perils of the Sloop ")]), _c('span', {
    staticClass: "ts39"
  }, [_vm._v("Racoon")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Our story now shifts to the sloop-of-war ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", of about 423 tons burthen, designed to carry 16 carriage guns. Typical of her time, she measured 108 feet 4 inches on the lower deck, and drew 9 feet. For this mission she had had an increase in ship’s complement to 130 and now carried 28 guns.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-49"
    }
  }), _vm._v("When, on New Year’s Day 1813, she “crossed the Line,” “Neptune came on board with his wife & train, mustered the Ship’s Company, found a great many new faces among us, ordered all hands stranger below, drank a Bottle of Wine with the Captain on the Quarter Deck, ordered his Carriage to drive to the Fore Castle, where he gave his orders to his Barbers &c. to commence shaving &c.” A bathing pool was created in the main deck area, and at the end of the day everyone washed up, “all hands about 9 P.M. quite boozy.” The first lieutenant, who wrote the above, concluded his day’s narrative: “Found myself rather by the head [intoxicated]. Shaped my course for my Cot. Turned in all standing, being more than half seized o’er.” So closed the day of crossing the equator in time-honoured tradition.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had rounded Cape Horn in heavy weather, all the while fighting high seas and cold winds. Cocos was reached October 7, and summer days lay ahead in these latitudes. Captain William Black of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("hoped to find the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("at Cocos, for in his instructions the island had been specified as a place to take on wood and water, if needed. Two days passed at Cocos without sighting the North West Company vessel, so the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("sailed for Juan Fernandez. Again there was no sign of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", though the enemy was rumoured to be near at hand. Then it was time to make sail for the Columbia. In due course the sloop recrossed the equator, and before long the tempestuous gales of the North Pacific, with heavy wind and rain, made their expected appearance. They were in latitudes where Captain James Cook, in 1778, had faced a series of gales and a long and weary approach to the Northwest Coast of America.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("During the exercise of the guns on October 20, a fearful explosion shook the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("; 21 men were injured.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn40",
      "id": "c1_n40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The burns were shocking in their intensity, and among the severely burned were John Macdonald of Garth and the first lieutenant, John Sherrif, whose hands suffered grievous injury. Apparently one of the guns, or at least the powder in the touchhole, misfired; fire leapt to some cartridges hanging above the gun, and a number of powder horns suspended from one of the joists exploded. The gunpowder, damaged by sea water, had become corrupted and thus unstable.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-50"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("By mid-November, 15 of the ship’s company were dead and had already been “committed to the Bowels of the Ocean on which we now exist,” wrote one officer. Large whales played and sounded round the ship, while the cruel wind came directly on their intended course, and it seemed to the "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("same officer that the vessel seemed to be running away from its destination. The weather continued very cold, but a new moon was expected to bring more favourable weather. In spite of her condition and reduced crew, preparations were made for “a grand attack” on Astoria, for on board the belief prevailed that the fort was in American hands.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn41",
      "id": "c1_n41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("About 80 men with marines were to land from three armed boats—the pinnace, cutter and gig—and take the post either by surprise at daybreak or under the ship’s fire. If the ship’s guns could not be brought to bear on the target, the landing party would “take the fort sword in hand.” The weather proved fickle, the shore cloaked in haze. In the evening they saw land at last. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("anchored under Cape Meares, just south of Tillamook Bay, and awaited the dawn.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("November 30 broke bright and clear with a smooth sea. More generally, from Cape Disappointment south to the opposite shore and Point Adams, outside the entrance to the Columbia, the sea presented itself as a fearful roil of wind and waves. Black sent boats ahead to sound a passage, there being a large bar at the entrance of the river, and to lay down buoys that had been readied for that precise purpose. This task completed, the sloop ran, with a fine following wind and under full canvas, through the marked gap and crossed the bar, and just after noon came to safe and welcome anchor in Baker’s Bay within Cape Disappointment. This was a brilliant feat of seamanship, for the Columbia’s bar was a graveyard for sailors, and the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("’s ship’s company knew boats sent by Captain Thorn of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Tonquin ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("in March 1811 had lost eight men. For his approach, Black had ordered no flags to be flown, so that their nationality could be kept secret. A boat party scrambled ashore with casks for water. Wood was available for ship’s fires, and timber for spars as required.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Across the river estuary, about six miles distant, the British traders at Astoria, who now controlled the Columbia, lived in continual fear of an American attack. They assumed that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was still at large; thus, the arrival of a warship caused understandable excitement and concern on shore. The guns of the fort fired four signal shots by way of welcome; no reply came from the ship that lay far across the river estuary.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-51"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Because no colours of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("could be seen from the fort, the Nor’westers prepared to abandon the post if the ship proved to be the enemy. At one o’clock in the afternoon, a party set off in a canoe to determine if")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("the man-of-war anchored in Baker’s Bay was friend or foe. Four hours later, when the canoe had failed to return, the traders on shore loaded most of their packs, arms and ammunition into barges and canoes to search for a more secure position up the river. However, toward midnight the original investigating party returned to the fort with joyous news that the unknown ship was the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". They had gone on board and celebrated her arrival with a large quantity of Tenerife wine, which accounts for their delay in returning with the good news.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn42",
      "id": "c1_n42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("It was a joyous day all round, and the")]), _vm._v(" Nor’westers ashore now had reassurance that the Royal Navy had arrived.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("Captain Black was a seasoned officer with 20 years in the Navy, a good deal of fighting experience and a keen sense of responsibility. He had entered the Navy in 1793, at the time the British had gone to war against the French, and then had served in ships on the Jamaica station, where the toast on Thursdays aboard ship was “A Bloody War or a Sickly Season” (and a quick promotion). He had studied history. From the outset he regarded the Northwest Coast, north of Alta California, as Nova Albion—that is, the territory Francis Drake had clamed for Elizabeth Regina in 1579. He discovered to his alarm that the Russians had erected a post, Fort Ross, north of San Francisco Bay, in 1812; in his opinion the Russians were disturbing the British sovereignty of Nova Albion. Black saw the world through the narrow prism of a dedicated naval officer on state business. If he was definite in his views, he was equally tactful and diplomatic. He was of the Nelson mode, determined to fulfill the mission his superiors had entrusted to him.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-52"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Next day, Captain Black, in one of his ship’s boats, examined the river mouth, using a copy of the remarkable chart drawn from the survey made by Lieutenant W.R. Broughton in 1792 when commanding the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Chatham ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("brig in Captain George Vancouver’s expedition. Broughton, we note, had performed the act of taking possession of that country in the name of King George III. Black planned to approach the post by the southern channel but, sadly, strong winds and tides forbade this. The weather was deplorable, the river estuary a churning mass, so the Nor’westers sent their coastal schooner ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Dolly")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", and, at last, after all these delays, on December 12, Black, at the head of a landing party, with a midshipman (Mr. Verdier), four marines and four sailors, reached shore below the fort. They were well entertained at the fort. Black donated some Madeira to the dinner festivities, and a")]), _vm._v(" pleasant evening ensued. There was much to talk about, as the demands of the voyage surely could be matched by the trials of overland travel. The traders acquired a high regard for Captain Black. The mariners were not so sure about the ferocious-looking fur traders, most of whom were Scots.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("On the next morning, December 13, Black is reported to have exclaimed in disgust when he saw the small stockade, with its slim armament, on a slight hill not far from the water, “Is this the fort about which I have heard so much talking? D–n me, but I’d batter it down in two hours with a four pounder!”"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn43",
      "id": "c1_n43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("Astoria stood on a rising ground overlooking a small, crescent-shaped bay where small ships could unload cargo into waiting boats and canoes that would ferry the goods to the wharf. To the west could be seen breakers on the river bar, rolling in wild confusion. To the east a desolate and varied aspect presented itself, and in the distance a magnificent, darkening forest. The fort itself was a square of 200 yards surrounded by a 15-foot palisade of timbers driven into the ground. Bastions stood at the northeast and southeast corners and were mounted with four- and six-pounders. A sentry platform topped the double gate facing the Columbia. Inside the palisade stood a two-storey governor’s house and some other buildings. The local Native people, the Chinook, posed no threat to the traders, and so no close guard need be kept on them. Even so, they were not permitted to stay the night and were obliged to leave at curfew, when the gates were closed. Outside the walls was an enclosure where the Kanakas, or Hawaiians, slept.")]), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("Although they were friendly, the Chinook were also frustratingly hard bargainers, as the Nor’westers discovered. They were accustomed to the presence of Europeans. The first to arrive were the Spaniards under Bruno de Hezeta in 1775, and the Americans under Robert Gray, who had explored the Columbia’s mouth in 1792. British trader John Meares had been near the river mouth in 1788, and Captain George Vancouver, RN, was there in April 1792, a month after Gray. The Lower Chinook became guardians of the mouth and lower reaches of the Columbia. It was a position they held zealously, personified in the form of the famed oneeyed Lower Chinook chief Comcomly (actually Madsu or “Thunderer”). Visits from trading vessels made the Lower Chinook rich and powerful. However, the introduction of spirituous liquors was a dramatic, hazardous occurrence on the Lower Columbia, and it did violence to Native ways.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-53"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("The Astorians were heavy-handed in dealing with Native matters upriver, where there was rivalry between the Chinook and the Nez Perce, but at Astoria the Nor’westers, though cautious, advanced their trade and security with little violence. Prevailing opinion among these traders was that a new post ought to be built upriver.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("At mid-afternoon on December 13, Black returned to the post in full uniform, with an armed escort. Coming before the assembled partners and employees of the North West Company, he signalled that the Union Jack be raised on the fort’s flagstaff. Then, breaking a bottle of Madeira on the staff, he declared in a loud voice that he was taking possession of “this country” in the name of His Britannic Majesty, and that he christened the post Fort George in honour of the king. After the appropriate cheers and salutes of musketry and artillery, there followed a toast to His Majesty and a speech to explain the new state of affairs to the Chinook people and other local Natives.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn44",
      "id": "c1_n44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The ceremony of possession clearly confirmed British control at Fort George, and Black’s act formally established the North West Company’s ownership of the post. He then sent this report overland, as deciphered, to the Admiralty:")])]), _vm._v(" "), _c('p', {
    staticClass: "quote ts4"
  }, [_vm._v("Country and fort I have taken possession of in name and for British Majesty; latter I have named Fort George and left in possession and charge North West Company.")]), _vm._v(" "), _c('p', {
    staticClass: "quotei ts4"
  }, [_vm._v("Enemy’s party quite broke up; they have no settlement whatever on this river or coast.")]), _vm._v(" "), _c('p', {
    staticClass: "quotei ts4"
  }, [_vm._v("Enemy’s vessels said on coast and about islands; while provisions last, shall endeavour to destroy them."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn45",
      "id": "c1_n45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-54"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "topindent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("A question often posed, and still unanswered for lack of evidence, is why did the Nor’westers purchase the post from the Astorians, as they did on October 16, when the naval force was known to be on its way? According to one person on board the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", the purchase was “diametrically opposite to the fundamental laws of Great Britain under the head of assisting an Enemy.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn46",
      "id": "c1_n46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("He and others in the British warship hoped that an Admiralty Court would show that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had captured the fort and that the value of the seizure would be given to the ship’s company. A generally held view, based on much hearsay evidence and without documentary proof, is that Captain Black thought the Nor’westers and Astorians conspired to defraud")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("him and his crew of the prize money.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn47",
      "id": "c1_n47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The controversy had both immediate and long-term consequences. Almost certainly, animosity developed between the sailors and fur traders over the objectives and spoils of war. Furthermore, this confused beginning of British control at the Columbia River mouth tended to complicate the British diplomatic position at discussions leading to the Treaty of Ghent in 1814 and afterward.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("On board the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", the dreaded appearance of scurvy and the lack of sufficient provisions forced Black to sail from the Columbia River much earlier than the fur traders judged to be in their best interests. Wildfowl and salmon delivered to the ship by the Natives and purchased by the North West Company were welcome. But they were insufficient to offset Black’s deep concern for the welfare of his ship’s company, and he decided to set a course for San Francisco. There he hoped to find additional provisions, after which he would sail in search of American fur-trading vessels known to winter in the Hawaiian Islands. December brought much heavy weather, delaying departure.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("At least one Nor’wester thought Black should sail directly for the Hawaiian Islands to capture “the whole nest” of wintering American vessels. It was proposed that the British fur traders buy one captured vessel for the use of the Nor’westers on the Northwest Coast. Black, however, explained that he could not sell them a prize ship unless an Admiralty Court had condemned it, and the nearest court was at the Cape of Good Hope.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn48",
      "id": "c1_n48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("He added that he intended to destroy any prizes to prevent them from being retaken by the enemy.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Black’s conduct won him the praise of his commander-in-chief, Rear-Admiral Dixon, when the latter advised the Lords of the Admiralty: “The service on which the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("has been employed has been most ably and meritoriously executed by Captain Black; he speaks highly of all his officers and ship’s company in several perilous and trying situations.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn49",
      "id": "c1_n49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("But")]), _vm._v(" some Nor’westers at Fort George had a different opinion. The grumbling Nor’wester Alexander Henry the Younger, whose overall views tended toward exaggeration, had this to say of Black and his men:")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-55"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Indeed with the exception of Captain Black, the Officers of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Raccoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("[")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("sic")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("] are not those vigilant, careful, active and fine enterprising fellows, so much talked of and admired by all the World, as")]), _vm._v(" the main prop of Great Britain. The Navy, were all His Majesty’s Naval Officers of the same stamp as those we saw here, England would not long have it in her power to boast of her Wooden Walls."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn50",
      "id": "c1_n50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "topindent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The fur traders at Fort George remained concerned about their security; they were still under the impression that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was at large. If they were attacked they would have to stand alone until the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("arrived. And many must have doubted that she would ever appear. No news had been received of that ship after she had separated from the squadron in late May 1813. She had failed to arrive at the Columbia, and therefore many at Fort George, traders and sailors alike, naturally feared that she had fallen prey to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", as rumoured, or otherwise had become a total loss. Yet they continued to hope she would arrive and alleviate the precarious position of the traders, who were further threatened by warlike preparations of the Chinook. In fact, the slow-sailing ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was then approaching Monterey, Alta California.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("At the Columbia the weather continued poorly through December, and between the ship and the fort the river was a turmoil of wind and waves. Black would have left earlier, but somehow he, or his clerk, had placed Lieutenant Broughton’s sailing instructions for the river entrance in the copy of Vancouver’s ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Voyage ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("that he had given to the fur traders at the fort. He needed to retrieve these instructions, and it took three perilous days and much worry to do so. Once this was accomplished, it was time to make sail at the opportune moment.")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-56"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("At daybreak on December 31, Mr. Stevens, the master, was sent to view the channel and report if he thought the ship could proceed outward bound in safety. He reported back that, yes, the channel appeared safe and clear, so sail was raised and the ship’s sailing master shaped the best course to exit the Columbia. Then came the unexpected: a tide, a fresh breeze aft and a heavy sea such that at times the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("would not answer the helm. The ship was now in peril. “This certainly was another dismal sight, and the Ship in critical situation. The sea breaking over us, the Ship pitching heavy & scarcely making head way presented a perilous aspect and caused the features of many brave men a gloomy appearance, particularly when she struck twice very hard. I believe few in the Ship expected any other than going to Davys locker in a crack. However, the will of providence")]), _vm._v(" ordained it otherwise this time,” wrote the author of the private journal."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn51",
      "id": "c1_n51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The strong ebb tide took control and drove the ship toward the bar. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", when crossing the bar, bounced badly on the bottom, and in the process her false keel was torn away.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("In damaged state, and in one of the great acts of seamanship, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("somewhat miraculously reached San Francisco Bay—with seven feet of water in her hold. The ship’s company, from constant employment at the ship’s pumps, was in a state of exhaustion. Captain Black looked to the Spanish authorities for assistance, as might be expected from this distressing state of affairs, but naval stores and assistance at Spain’s San Francisco presidio, northern bastion of New Spain, proved inadequate or unobtainable. Spanish authorities exhibited politenesses but were otherwise unhelpful. In these woeful circumstances, Black and his officers had no option but to consider abandoning the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and returning to England overland via Mexico. Then providence seemed to intervene. At Monterey, capital of Alta California, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("got word of the arrival of the wounded ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". The merchantman found the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("at San Francisco Bay and provided stores and many essentials, including physical help. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was hove down on the beach at Ayala Cove, Angel Island, March 13 to 19, and repairs were effected. She was re-rigged and made ready to sail. The resourcefulness of mariners when in distress on distant shores always invites our admiration. Even so, the historian ponders the role of fate and even the agency of synchronicity. One British officer commented that it seemed as if the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had been “sent as by the works of our maker.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn52",
      "id": "c1_n52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-57"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("All hands readied the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("for sea. The time had come for British tars and Canadian fur traders to say their goodbyes. The two ships parted company and then stood out under full canvas through the Golden Gate. On January 19, 1814, the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("shaped a course for fair Hawaii on the hunt for American shipping. Black’s long cruise to the Pacific ended with his successful return to England. Half of the ship’s company had not survived on account of sickness and accident. The 27-year-old lieutenant who had kept his private journal had seen all the perils of the deep except drowning. From Portsmouth to Rio, round the Horn and back, calls at Juan Fernandez and other places, then to the cold and stormy Columbia, then home via Maui and Tahiti, with grog often in short supply—this was")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("the sailor’s life, and the absence from home was often the telling thing, though service in the name of King George might be something to boast of in later years. The sloop-of-war ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had completed one of the most astonishing voyages on record, and Captain Black became a rear-admiral. (There are many similarities in this expedition to that of Jack Aubrey’s ship ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Surprise")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", as portrayed in the movie ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Master and Commander: The Far Side of the World")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", except that the enemy was American and not the customary and dreaded French, and the whaler-hunting ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was rechristened ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Acheron")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".) The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("’s last days were spent as a convicts’ hospital ship in Portsmouth.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("As for the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", her story may be briefly told. She sailed from San Francisco for the dark and dreary Northwest Coast, and arrived at the mouth of the Columbia on April 23, 13 weary months after leaving Portsmouth. Her welcome arrival at the old Astoria (now Fort George), with arms and ammunition, provisions and supplies of all kinds and distinctions, ensured the preservation of British interests at Fort George during wartime. Both objectives of Hillyar’s bold decision were achieved: the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had been captured, and control of the Columbia River mouth rested in British hands. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("sailed for Canton and eventually returned home to England with Chinese goods and sea-otter furs.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("By the time the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("reached Fort George, the North West Company had sent the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Columbia ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("from England, also bound for the Northwest Coast. Again, a ship of the Royal Navy, HMS ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Laurel")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", provided a welcome convoy, this time only as far as Rio de Janeiro. The ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Columbia ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("arrived at the strongly fortified Fort George in July 1814.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn53",
      "id": "c1_n53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Annually")]), _vm._v(" thereafter, ships brought supplies and took away furs bound for the China market. Thus had Sir Alexander Mackenzie’s dream been realized. The British succeeded in establishing the Columbian enterprise even while the War of 1812 made extensive demands on the Royal Navy in various places on the high seas. Even today the long arm of British sea power, as exercised in those years so long ago, invites our admiration, but of particular attraction is the skill and endurance of sailors and those who were knowledgeable in “the haven-finding art.” The age of fighting sail, of which the War of 1812 is highly illustrative, formed one of the most remarkable eras in human history—and provided one of the most dramatic incidents in the annals of the Pacific Ocean and the Northwest Coast. Few others are its equal.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-58"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "section ts38"
  }, [_vm._v("The Quarrel Begins")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Now commenced the paper war for the Columbia River country. Given the Anglo-American rivalry to control the Columbia trade between 1810 and 1814, and the immense expense and difficulty involved—to say nothing of the challenges faced—it seems paradoxical that when peace negotiations began at Ghent, the British government showed little concern for the territory west of the Rocky Mountains. Sailors and diplomats do not always see eye to eye. The criminally neglectful silence of the British plenipotentiaries was later explained to the North West Company by Earl Bathurst, the secretary for war and the colonies, on the grounds that “requiring from the Americans any recognition or guarantee of His Majesty’s rights thereto, might lead to cast doubts upon a title which was sufficiently strong and incontrovertible.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn54",
      "id": "c1_n54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Such was the excuse for what was probably an oversight. It is also an example of diplomatic double-talk. The French liked to call the British “perfidious Albion.” They were ever on their guard against British diplomatic double-dealing.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The American plenipotentiaries took an assertive standpoint. At Ghent they argued aggressively that Astoria should be restored to the United States because it had been in American hands before the war. This reflected the policy of the secretary of state, James Monroe, who instructed the delegation to insist on the restoration of the fort. With reference to the British, Monroe noted, “It is not believed that they have any claim to territory on the Pacific Ocean.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn55",
      "id": "c1_n55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Ultimately, the Treaty of Ghent, signed December")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("24, 1814, stipulated a return to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("status quo ante bellum")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(". Both during and after negotiations, the Nor’westers made repeated appeals to the British government for protection against the Americans. They hoped to safeguard their post on the Columbia, which they claimed had been acquired by purchase.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn56",
      "id": "c1_n56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Nevertheless, the Treaty of Ghent failed to make specific reference to the fort at the Columbia River mouth. In fact, the treaty’s “only definite achievement,” according to one authority, “was the termination of hostilities.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn57",
      "id": "c1_n57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Altogether, the treaty was an unsatisfactory agreement and")]), _vm._v(" the cause of later disputes between Britain and the United States. But it was the best in the circumstances of the day.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-59"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("After signing the treaty, the United States government took steps to recover the post on the Northwest Coast. Secretary of State Monroe told the British minister in residence, Anthony St. John Baker, that inasmuch as "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("the British force had taken possession of Astoria during the war, the United States intended to reoccupy the fort without delay.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn58",
      "id": "c1_n58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("When Monroe asked")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("that a letter be addressed to the British naval commander in the North Pacific ordering the return of the fort to the Americans, Baker replied that he knew very little about the fate of Astoria, although he believed that the post lay in ruins and was unoccupied.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn59",
      "id": "c1_n59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Baker suggested that Sir Manley")]), _vm._v(" Dixon, commander-in-chief on the South American station and in charge of British warships in the Pacific, would possess authentic information and could communicate with any authorized American agent on the subject. This useful ploy earned the British some needed time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Immediately Baker wrote to Dixon to warn him of the developments in Washington. He enclosed copies of the correspondence with Monroe and emphasized that Britain did not recognize any American possession on the Pacific coast.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn60",
      "id": "c1_n60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Although Baker did learn from the North West Company")]), _vm._v(" in Canada that the possession of Astoria was effected by purchase, he failed to press this advantageous position with the American secretary of state.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("It is generally believed that only the lack of naval units during 1815 and 1816 prevented the United States from sending a vessel on a mission of restitution to the Northwest Coast.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn61",
      "id": "c1_n61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("A suggestion in the autumn of 1815 that a naval expedition explore the Northwest Coast won support from President James Madison, but the need for economy caused the proposal to be set aside. The USS ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Congress")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", which was to sail in mid-1816 for the Pacific, had to be sent to the Gulf of Mexico instead. Something more secretive was now put into operation. On October 4, 1817, the American sloop-of-war ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Ontario")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", 20 guns, under Captain James Biddle, sailed from New York for the Columbia on an ill-advised secret mission to take possession of Astoria. But when Simon McGillivray of the North West Company learned of this through a breach in security, he immediately informed Sir Charles Bagot, the British chargé d’affaires in Washington.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn62",
      "id": "c1_n62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("John Quincy")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Adams, US secretary of state, appeared “considerably embarrassed” when Bagot asked him if the rumour were true. He admitted that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Ontario ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was sent to assert American sovereignty, but not to destroy the trade of the North West Company.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn63",
      "id": "c1_n63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-60"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("Bagot was not satisfied with the response. Immediately he notified Viscount Castlereagh, the British foreign secretary, that a vessel had been ordered “to the mouth of the Columbia River for the purpose of re-establishing "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("the Settlement of which the United States was dispossessed during the late war.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn64",
      "id": "c1_n64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Bagot then advised the Governor General of Canada to send an overland party to warn the Nor’westers on the Pacific coast.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn65",
      "id": "c1_n65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Optimistically, he")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("suggested to the foreign secretary that a vessel from England could arrive at the Columbia before the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Ontario")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(".")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn66",
      "id": "c1_n66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("But nothing was done in response to Bagot’s advice.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("Further information reached the Admiralty from Commodore Sir James Lucas Yeo, commander-in-chief on the West African Coast, that the Americans possessed a “restless and hostile spirit” toward Britain.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn67",
      "id": "c1_n67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("He")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("also reported that he learned during his visit to New York that the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Ontario ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("was sailing for the North Pacific with commissioners on board “to obtain possession of some Island or Territory in that quarter preparatory to their establishing a very extensive commerce in those Seas.”")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn68",
      "id": "c1_n68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The British cabinet considered this explosive situation and sought to avert a renewal of war. The foreign secretary, Castlereagh, knew that the Nor’westers had actually purchased Astoria—and that tied his hands. But the dilemma arose because Captain Black’s report indicated that he had claimed that territory as a conquest of war: provision in the Treaty of Ghent to return to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("status quo ante bellum ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("meant that Britain had to return any conquest of war. The conciliatory foreign secretary clearly was more interested in the stability of international relations than in additions to the British Empire. In order to give the Americans what he referred to generally as “an additional motive to cultivate the arts of peace,” he decided to return the post to the Americans provided it was abundantly clear to them that this would neither recognize United States rights nor relinquish British claims to the territory.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn69",
      "id": "c1_n69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" To implement this generous, albeit shortsighted, policy, he instructed the secretary for war and the colonies, Earl Bathurst, to inform the fur traders of the proposed restitution of Fort George, previously Astoria, to the United States. At the same time, Castlereagh instructed the Admiralty to send a warship to the Northwest Coast to restore the post officially to American commissioners."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn70",
      "id": "c1_n70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-61"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The mission was carried out by the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Blossom")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", 18 guns—a “ship-sloop” and sister to the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("—which was previously engaged in protecting British commerce in ports on the Pacific side of South America during the war between Spain and Chile. She sailed from Valparaiso for the Columbia on July 12, 1818, carrying Colonial Office dispatches to the")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("Nor’westers authorizing the restitution.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn71",
      "id": "c1_n71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("By the time she had anchored")]), _vm._v(" "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("near Fort George on October 1, the American ship ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Ontario ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("had arrived, made territorial claims for the United States and departed.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn72",
      "id": "c1_n72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("The British")]), _vm._v(" fur traders, unsure whether peace or war existed, had made preparations to defend the post."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn73",
      "id": "c1_n73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "section ts38"
  }, [_vm._v("The Dispute Unresolved")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("In official ceremonies that followed, Captain Frederick Hickey of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Blossom ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and James Keith, a British commissioner and the factor in charge of the fort, signed the Instrument of Restoration. Then the British flag was lowered and the flag of the United States was raised. This act, which must have seemed as ridiculous to the participants as it does now, was intended to symbolize American “ownership” of Fort George. But it did not end the confusion. The Nor’westers continued to use the post as their headquarters on the Northwest Coast for many years. It remained the chief depot of the Hudson’s Bay Company, which merged with the North West Company in 1821, until 1825, when Fort Vancouver was erected.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "ts4"
  }, [_vm._v("The territorial claims made when the USS ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Ontario ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("came to the Columbia in October 1817 convinced the British ministry that differences between the United States and Britain should be resolved to maintain peace. In the negotiations that led to the Anglo-American Convention of 1818, the British proposed an international boundary along the Columbia River and joint occupancy of the land at the river mouth.")]), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Notes#c1_fn74",
      "id": "c1_n74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("This, however,")]), _vm._v(" was unacceptable to the United States. The parties finally agreed to what has been called a joint occupation of the so-called Oregon Territory—that is the territory lying between Spanish-held Alta California and Russian America, and between the Continental Divide and the Pacific coast. The Anglo-American Convention of 1818 postponed negotiations between Britain and the United States on territorial claims to Oregon. Failure to resolve the dispute at this time confused rival traders, mariners and diplomats for many years and nearly embroiled the two nations in war in 1846.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "VPS-62"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("By 1818, British dominance in the fur trade at the mouth of the Columbia, and thus over the hinterland, had been gained with the aid of the Royal Navy. In particular, and of critical importance, convoy support given the Nor’westers by British warships during the War of 1812, the "), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("success of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Phoebe ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Cherub ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("against the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Essex")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v(", and the completion of the missions of the ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Racoon ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("and ")]), _c('span', {
    staticClass: "ts12"
  }, [_vm._v("Isaac Todd ")]), _c('span', {
    staticClass: "ts4"
  }, [_vm._v("ensured continuation of British fur-trading interests on the Northwest Coast. Although the contest for the Columbia country ended in Britain’s favour in terms of trade, the unwillingness of the war-weary British ministry to obtain recognition from the United States in 1815 and 1818 of British territorial control led to protracted negotiations during the next three decades. The American war did not achieve the aim of annexing Canada, but it did give Americans full jurisdiction over the Native tribes south and west of the Great Lakes within the national boundaries of the United States. The British reneged on their promise to protect the Native nations south of the line, and this sadly prefaced the British withdrawal. Beyond the Mississippi, in time, as Manifest Destiny gathered momentum, settlement projects and missionary societies advanced their interests, and independent fur traders, the mountain men, worked the margins of what became, after 1821, the Hudson’s Bay Company’s imperium.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent ts4"
  }, [_vm._v("Out on the far western margin of the continent, the rivals were exercising sea power and determining the course of history. The “sloop diplomacy” practised during the war set the pattern that would be followed for almost a hundred years in these seas. Antipathies between John Bull and Brother Jonathan, begun in the War of American Independence, were reinforced by the War of 1812. By 1818 the final struggle for territorial control in the farthest west had started in earnest. At the time, no one could imagine that the two countries would quarrel over more than just Oregon, but would also have a spat over the San Juan Archipelago, the Alaska–Yukon Boundary and the Bering Sea pelagic sealing grounds. In the waters beyond Cape Horn, the grand duel was being acted out bit by bit in a great contest of wills, and of threats and counter-threats. It was one in which, on both sides, the quality of ships, their provisioning and repair, and the skills of the officers in command and the sailors under discipline who sailed those distant seas far from home are to this day a matter of wonder and admiration.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b79e3c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Chapter_1.vue
// module id = 87
// module chunks = 0